/**
 *
 * @param data The object to traverse
 * @param targetId The ID to recursively search for
 * @param ancestors Each recursive call uses a new copy of the ancestors array to maintain the correct state at each level of recursion
 * @param idMap Stores each ID with its ancestor path
 * @returns An array of ancestor IDs for the specified targetId (including the targetId)
 */
export default function findAncestorIds(
  data,
  targetId,
  ancestors = [],
  idMap = new Map()
) {
  if (Array.isArray(data)) {
    for (const item of data) {
      const result = findAncestorIds(item, targetId, ancestors, idMap);
      if (result) return result;
    }
  } else if (typeof data === 'object' && data !== null) {
    if (data.id) {
      const currentAncestors = [...ancestors, data.id];
      idMap.set(data.id, currentAncestors);
      if (data.id === targetId) {
        return currentAncestors;
      }
      for (const key in data) {
        if (data.hasOwnProperty(key) && typeof data[key] === 'object') {
          const result = findAncestorIds(
            data[key],
            targetId,
            currentAncestors,
            idMap
          );
          if (result) return result;
        }
      }
    } else {
      for (const key in data) {
        if (data.hasOwnProperty(key) && typeof data[key] === 'object') {
          const result = findAncestorIds(data[key], targetId, ancestors, idMap);
          if (result) return result;
        }
      }
    }
  }

  return null;
}
